import React from 'react';
import { MapPin, Store } from 'lucide-react';
import { Card } from './ui/card';

const Retailers = () => {
  const retailers = [
    {
      name: "Sullivan's",
      locations: [
        "Kentwood, LA",
        "Gluckstadt, MS",
        "Flora, MS",
        "Clinton, MS",
        "Lake Village, AR",
        "Brookhaven, MS"
      ],
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/hedchl41_Sulivans-Foods.jpg"
    },
    {
      name: "Shopper's Valu",
      locations: [
        "Greenville, MS",
        "Indianola, MS",
        "Clinton, MS",
        "Shreveport, LA",
        "Ringold, LA",
        "Vivian, LA",
        "Ruston, LA"
      ],
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/qxc4m847_Shoppers-Value.jpg"
    },
    {
      name: "Morgan's",
      locations: [
        "Vicksburg, MS"
      ],
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/lp5vrinx_Morgans-Grocery.jpg"
    },
    {
      name: "Vicente",
      locations: [
        "Brockton, MA"
      ],
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/ttymls0l_Vicente%27s-Super-Market.jpg"
    },
    {
      name: "Food Depot",
      locations: [
        "Mississippi"
      ],
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/zyqeoc6v_Food-Depot.jpg"
    },
    {
      name: "America's Food Basket",
      locations: [
        "Boston, MA",
        "Jonesboro, GA"
      ],
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/nvvoq791_Americas-Food-Market.jpg"
    }
  ];

  const georgiaStores = [
    {
      name: "Food Depot",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/zyqeoc6v_Food-Depot.jpg"
    },
    {
      name: "Little Giant Farmers Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/fg5qth6m_Little-Giant.jpg"
    },
    {
      name: "City Farmers Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/zusm895j_City-Farmers-Market.jpg"
    },
    {
      name: "Hong Kong Farmers Market",
      logo: null
    },
    {
      name: "Austell International Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/do9j9pvp_Austell-Farmers-Market.jpg"
    },
    {
      name: "International Cordova Farmers Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/wx4u40zm_Cordova-Farmers-Market.jpg"
    },
    {
      name: "Fiesta",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/oat7ss11_Fiesta.jpg"
    },
    {
      name: "Gordon's Butcher & Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/9lm8clqu_Gordons-Butcher-Market.jpg"
    },
    {
      name: "Hatfields Country Store",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/3dpo5vm5_Hatfields-Country-Store.jpg"
    },
    {
      name: "Kaye's Food Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/19lvz0va_Kayes-Food-Market.jpg"
    },
    {
      name: "Save-A-Lot",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/ae7aeq22_Save-A-Lot.jpg"
    },
    {
      name: "Sunflower Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/xs296d0i_Sunflower-Market.jpg"
    },
    {
      name: "Super Valu",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/9rcdq2qy_Super-Valu.jpg"
    },
    {
      name: "The Corner Grocery",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/ffay7d53_The-Corner-Grocery.jpg"
    },
    {
      name: "Value Food Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/cwk1a4h7_Value-Food-Market.jpg"
    },
    {
      name: "Winchester Farmers Market",
      logo: "https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/1qjgqxe4_Winchester-Farmers-Market.jpg"
    }
  ];

  return (
    <section id="retailers" className="retailers-section">
      <div className="retailers-container">
        <div className="section-header">
          <span className="section-badge">Where to Buy</span>
          <h2 className="section-title">Find CSS Caribbean Meal Near You</h2>
          <p className="section-description">
            Our authentic Caribbean frozen dinners are available at these fine retailers across multiple states.
          </p>
        </div>

        <div className="retailers-grid">
          {retailers.map((retailer, index) => (
            <Card key={index} className="retailer-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="retailer-header">
                {retailer.logo ? (
                  <div className="retailer-logo-container">
                    <img src={retailer.logo} alt={`${retailer.name} Logo`} className="retailer-logo" />
                  </div>
                ) : (
                  <div className="retailer-icon">
                    <Store size={28} />
                  </div>
                )}
                <h3 className="retailer-name">{retailer.name}</h3>
              </div>
              <div className="retailer-locations">
                {retailer.locations.map((location, locIndex) => (
                  <div key={locIndex} className="location-item">
                    <MapPin size={16} />
                    <span>{location}</span>
                  </div>
                ))}
              </div>
            </Card>
          ))}
        </div>

        <div className="georgia-stores-section">
          <h3 className="georgia-title">Additional Georgia Locations</h3>
          <div className="georgia-stores-grid">
            {georgiaStores.map((store, index) => (
              <div key={index} className="georgia-store-item">
                {store.logo ? (
                  <div className="georgia-logo-container">
                    <img src={store.logo} alt={`${store.name} Logo`} className="georgia-logo" />
                  </div>
                ) : (
                  <Store size={18} />
                )}
                <span>{store.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="retailers-cta">
          <div className="cta-box-retailers">
            <h3>Can't Find Us Near You?</h3>
            <p>Contact us to learn about upcoming retail locations or inquire about wholesale opportunities.</p>
            <a href="#footer" className="contact-link">Get in Touch</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Retailers;
